import {View, useWindowDimensions, TouchableOpacity} from 'react-native-web';
import {ImageFull, Logo, LogoTribu1, ImageFullHome} from './Image';
import Ionicons from 'react-native-vector-icons/Ionicons';
import { Title, Body, SheeTitle } from './Text';
import {useState} from 'react';
import { ButtonBlack, ButtonUser } from './Button';

const CardUser = props =>{
 
 const [icons, setIcons]=useState(props.icon)
 const [logo , setLogo]=useState(props.logo)
console.log(props.maxWidth)
return(
<View style={{backgroundColor:'#303030', borderRadius:30, width:props.width, height:props.height,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:8, shadowOffset:{width:5, height:5 }, marginTop:15, maxWidth:props.maxWidth}}>
      {logo?<Logo/>:<></>}
      {icons?<Ionicons color={'#F9BA49'} size={24} name={'arrow-back'} style={{position:'absolute', top:16, left:16}} onPress={props.onPress}/>:<></>}
      
      {props.children}
</View>);}

const CardHome = ({image, title, body, hsize})=>{
  const windows= useWindowDimensions()
  const [flip, setFlip]= useState(false)
  return(
   
    <View style={{backgroundColor:'#303030', borderRadius:30, width:windows.width*0.95, height:windows.height*0.8,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:10, shadowOffset:{width:5, height:5}, marginTop:15, maxWidth:450}}>
       <Ionicons color={'#F9BA49'} size={24} name={'arrow-redo'} style={{position:'absolute', bottom:15, right:15}} onPress={()=>setFlip(!flip)}/> 
       {flip? <View style={{with:'90%', height:'90%', marginTop:35}}><Body value={body} color1={'#F9BA49'}/></View>:
       <View style={{with:'90%', height:'90%'}}><ImageFullHome image={image} hsize={'85%'}/>
        <Title value={title} color1={'#F9BA49'}/>
        </View>}
    </View>
      );}

  const CardEvent = ({image, title})=>{
    const windows= useWindowDimensions()
    return(
     
      <View style={{backgroundColor:'#303030', borderRadius:32, width:windows.width*0.95, height:windows.height*0.8,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:10, shadowOffset:{width:5, height:5}, marginTop:15, maxHeight:800, maxWidth:350}}>
          <ImageFull image={image} hsize={'80%'}/>
          <View style={{width:'100%', height:'20%', alignItems:'center', marginTop:30}}>
          <Title value={title} color1={'#F9BA49'}/>
          </View>
        </View>);}

  const CardDetail = props =>{
    const windows= useWindowDimensions()
    var hsize=props.hsize
    return(
  <View style={{backgroundColor:'#303030', borderRadius:32, width:windows.width*0.95, height:windows.height*hsize,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:10, shadowOffset:{width:5, height:5}, maxHeight:800, maxWidth:350, alignSelf:'center'}}>
   {props.children}
   {props.icon1?  <Ionicons color={'#F9BA49'} size={24} name={'close-circle'} style={{position:'absolute', top:15, right:15}} onPress={props.onPress}/> :<></>}
   {props.icon2? <Ionicons color={'#F9BA49'} size={24} name={'arrow-redo'} style={{position:'absolute', bottom:props.bottom, right:props.right}} onPress={props.onPress1}/> :<></>}
  </View>
    );}

    const CardModal = props =>{
      const windows= useWindowDimensions()
      var hsize=props.hsize
      return(
    <View style={{backgroundColor:'#303030', borderRadius:32, width:windows.width*0.95, height:windows.height*hsize,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:10, shadowOffset:{width:5, height:5}, marginTop:15, maxHeight:800, maxWidth:350, alignSelf:'center', justifyContent:'center', borderColor:'#F9BA49', borderWidth:1.8}}>
      
     {props.children}
     {props.icon1?  <Ionicons color={'#F9BA49'} size={24} name={'close-circle'} style={{position:'absolute', top:30, right:30 }} onPress={props.onPress}/> :<></>}
     {props.icon2? <Ionicons color={'#F9BA49'} size={24} name={'arrow-redo'} style={{position:'absolute', bottom:30, right:30}} onPress={props.onPress1}/> :<></>}
    </View>
      );}

      const CardCaracter = props =>{
        const windows= useWindowDimensions()
        const Complete = props.Complete

        function Type (){
          if(Complete==true){
            let text = 'Confermato';
            return text}
          
         if(Complete==false){
            let text = 'da Confermare';
            return text
          }
        if (Complete=='MORTO'){
          let text = 'MORTO'
          return text
        }
        
        }
       
        return(
          
        <TouchableOpacity style={{backgroundColor:'#303030', borderRadius:32, width:windows.width*0.95, height:windows.height*0.2,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:10, shadowOffset:{width:5, height:5}, maxHeight:800, maxWidth:350, alignSelf:'center', borderColor:props.color2, borderWidth:1.8, padding:15}} onPress={props.onPress}>
        <View style={{width:'100%', height:'100%', flexDirection:'row'}}>
        <View style={{width:'50%', height:'100%', alignItems:'center', justifyContent:'center'}}>
        
        <LogoTribu1 wsize={'100%'} hsize={'100%'} source={props.tribeImage}/>
        </View> 
        <View style={{width:'50%', height:'100%'}}>
        <SheeTitle value={props.Name} color1={props.color2}/> 
        <Body value={Type()} color1={props.color2}/> 
        </View> 
        </View>
        </TouchableOpacity>
        );}

        const CardInterlude = ({image, title, onPress, onPress1})=>{
          const windows= useWindowDimensions()
          return(
           
            <View style={{backgroundColor:'#303030', borderRadius:32, width:windows.width*0.95, height:windows.height*0.9,  shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:10, shadowOffset:{width:5, height:5}, marginTop:15, maxHeight:800, maxWidth:350}}>
                <ImageFull image={image} hsize={'60%'}/>
                <Title value={title} color1={'#F9BA49'}/>
                <Body value={"Ti senti pronto per proseguire e creare il tuo PG, o preferisci leggere prima qualcosa d'ambientazione?\n\nTroverai tutti i materiali ambientativi nella sezione download raggiiungibile dal menù menu laterale"} color1={'#F9BA49'}/>
                <View style={{width:'100%', height:'15%', flexDirection:'row', justifyContent:'space-around', marginTop:15}}>
           <ButtonUser text={'Continua'} wsize={'40%'} onPress={onPress}/>
           <ButtonBlack text={'Più Tardi'} wsize={'40%'} onPress={onPress1}/>
       </View>   
            </View>
              );}


export  {CardUser, CardHome, CardEvent, CardDetail, CardModal, CardCaracter, CardInterlude}